import { AssetWithProof } from './getAssetWithProof';
import { DasApiAsset } from './rpc';

function isAssetWithProof(
  asset: AssetWithProof | DasApiAsset
): asset is AssetWithProof {
  return 'rpcAsset' in asset;
}

export function canTransfer(asset: AssetWithProof | DasApiAsset): boolean {
  const ownership = isAssetWithProof(asset)
    ? asset.rpcAsset.ownership
    : asset.ownership;

  const isFrozen =
    ownership.frozen === true || ownership.non_transferable === true;
  return !isFrozen;
}
